<template>
  <div class="ButtonProduct" :class="[isZeborne ? 'zeborne' : 'mcp', {'isLead': isLead}, {'isPac': isPac}]">
    <template v-if="productUniverse.toLowerCase().includes('sèche-serviette')  || productUniverse.toLowerCase().includes('radiateur') || isAccessoryProduct">
      <span>Quantité :</span>
      <select
          autocomplete="off"
          name="quantity-product"
          @change="updateQuantity"
          id="quantity"
          :value="preprendCartQuantity"
      >
        <option :value="value" :id="value" v-for="(value, index) in quantityDefault" :key="index">{{
            value
          }}</option>
      </select>
    </template>

    <button
        :style="{ width: percentProgress + '%' }"
        class="Button Button-validate"
        @click.prevent="addProductToCartAction"
        :disabled="!productShippingInfo.available"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
import EventBus from "@/event-bus";
import { mapGetters, mapActions } from "vuex";

import "@/components/ButtonProduct/ButtonProduct.scss";
import "@/components/ProgressButton/ProgressButton.scss";

export default {
  name: "ButtonProduct",

  data() {
    return {
      percentProgress: 100,
      quantityDefault: 20,
      buttonText: '',
      baseUrl: process.env.VUE_APP_API_BASE_URL,
    };
  },

  computed: {
    ...mapGetters({
      selectedDeliveryDateStart: "getDeliverySelectedDateStart",
      selectedDeliveryId: "getDeliverySelectedId",
      currentDeliveryId: "getDeliveryCurrentId",
      preprendCartQuantity: "getPreprendCartQuantity",
      isZeborne: "isZeborne",
      isLead: "isLead",
      productShippingInfo: "getProductShippingInfo",
      isPac: "isPac",
      productUniverse: "getProductUniverse",
      isAccessoryProduct: "isAccessoryProduct",
      preprendCartData: "getPreprendCartData",
      storeUrlPrefix: "getStoreUrlPrefix",
    }),
  },

  methods: {
    addProductToCartAction() {
       if(this.selectedDeliveryDateStart !== '' && this.productUniverse === "Ballon d'eau chaude" ) {
        window.location = process.env.VUE_APP_API_BASE_URL + this.storeUrlPrefix + '/checkout/cart';
      } else {
        EventBus.$emit("submit-form");
      }
      
    },

    updateQuantity(event) {
      this.setPreprendCartQuantity(event.target.value);
    },

    ...mapActions(["setPreprendCartQuantity"]),
  },

  mounted() {
    if(this.isLead) {
      this.buttonText = "Obtenir mon devis"
    } else {
      this.buttonText = "Ajouter au panier"
    }
  },

};
</script>
